import { render, staticRenderFns } from "./getFriendRequest.vue?vue&type=template&id=f828b23a&"
import script from "./getFriendRequest.vue?vue&type=script&lang=js&"
export * from "./getFriendRequest.vue?vue&type=script&lang=js&"
import style0 from "./getFriendRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports